import { createContext } from "react";
import type { FormationContextType } from "./Formation";
import { StoreApi } from "zustand";

export const FormContext = createContext<StoreApi<FormationContextType>>(null!);
